<template>
  <div></div>
</template>

<script>
import { getMixinAuth } from '@/api/user';
import { Toast } from 'mand-mobile';
import { mapState } from 'vuex';
export default {
  computed: mapState({
    isLogin: state => state.isLogin,
  }),
  created() {
    if (this.isLogin) {
      this.$router.replace('/exchange');
      return;
    }
    getMixinAuth()
      .then(data => {
        return window.location.replace(data.data.url);
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
};
</script>
